import React from 'react';

export default ({
  boatSystems,
  currentSystem,
  allComponents,
  selectedCombination,
  handleCombinationChoose,
  getCombinationCompositionReminder,
}) => {
  const activeSystem = boatSystems[currentSystem.index];

  if (!activeSystem || currentSystem.combinations.length <= 1) return null;

  function _handleCombinationChoose(index) {
    return () => {
      handleCombinationChoose(index);
    };
  }

  return (
    <section className='scene_section'>
      <header>{activeSystem.name}</header>
      {getCombinationCompositionReminder()}
      <div className='boat-systems-scene__configuration-chose-button-holder'>
        {currentSystem.combinations.map((combination, index) => {
          return (
            <div
              key={combination.id}
              className={`boat-systems-scene__configuration-chose-button ${
                selectedCombination.id === combination.id ? 'active' : ''
              }`}
              onClick={_handleCombinationChoose(index)}
            >
              <p>{`Configuration ${index + 1}`}</p>
            </div>
          );
        })}
      </div>
      <p className='boat-systems-scene__configuration-additional-reminder-text'>
        Attention: Choosing Configuration allows to add different component types.
      </p>
    </section>
  );
};



// WEBPACK FOOTER //
// ./src/app/Scenes/BoatManufacturer/Application/New/AddComponents/CombinationPicker.jsx